import { render, staticRenderFns } from "./percentage-report.vue?vue&type=template&id=ebaef162"
import script from "./percentage-report.vue?vue&type=script&lang=js"
export * from "./percentage-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports